import type { JSX } from 'react'
import { Route, Routes } from 'react-router-dom'
import AuthPage from '../Auth'
import BanishmentsPage from '../BanishmentsPage/BanishmentsPage'
import BrowseCreditApplicationsPage from '../BrowseCreditApplicationsPage'
import CreditTaskDashboardPage from '../CreditTaskDashboardPage'
import CreateCreditApplicationPage from '../EditCreditApplicationPage/CreateCreditApplicationPage'
import FeaturesSwitchForm from '../FeatureSwitch/FeaturesSwitchForm'
import Home from '../Home/HomePage'
import LoginPage from '../Home/LoginPage'
import AgentLogReportPage from '../Reports/AgentLogReportPage'
import PayoutThatSkippedIncomeValidation from '../Reports/PayoutThatSkippedIncomeValidation'
import Reports from '../Reports/Reports'
import ManageTestCase from '../TestCaseManagement/ManageTestCasePage'
import LoadCreditApplication from './LoadCreditApplication'
import NotFoundPage from './NotFoundPage'
import RouteGuard from './RouteGuard'

const TopLevelRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="home" element={<Home />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="creditTasksDashboard" element={<CreditTaskDashboardPage />} />
      <Route path="auth-page" element={<AuthPage />} />
      <Route path="applications">
        <Route path="browse" element={<BrowseCreditApplicationsPage />} />
        <Route element={<RouteGuard requiredPermission="canEditCreditApp" />}>
          <Route path=":financingProgramId/add" element={<CreateCreditApplicationPage />} />
        </Route>
        <Route path=":financingProgramId/:id/*" element={<LoadCreditApplication />} />
      </Route>
      <Route path="reports">
        <Route path="payoutThatSkippedIncomeValidation" element={<PayoutThatSkippedIncomeValidation />} />
        <Route path="agentLog" element={<AgentLogReportPage />} />
        <Route path="" element={<Reports />} />
      </Route>
      <Route path="banishments" element={<BanishmentsPage />} />
      <Route path="featureSwitch" element={<FeaturesSwitchForm />} />
      <Route path="manageTestCases" element={<ManageTestCase />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default TopLevelRoutes
